import "./SelectPieChartKPI.css";

import { ReactNode } from "react";

import { SelectData } from "../../../../models";
import { Select } from "../../..";
import { ChartDataWithSuffix, PieChart, PieChartCenterTextFont, PieChartColors } from "../../../charts";
import { Card, Column, Row } from "../../../layout";

export interface SelectPieChartKPIProps {
  data: { [key: string]: number };
  title: string;
  hasSuffix?: boolean;
  dataWithSuffix?: ChartDataWithSuffix;
  centerTextSuffix?: string;
  centerTextPrefix?: string;
  size?: number;
  colours?: PieChartColors;
  noDataMessage?: string;
  tooltip?: ReactNode;
  showValues?: boolean;
  isGradient?: boolean;
  centerTextFont?: PieChartCenterTextFont;
  chartColorsOverride?: string[][];
  selectData: SelectData;
  selectedValue?: string;
  onChange: (value: string) => void;
}

export const SelectPieChartKPI = ({
  data,
  title,
  hasSuffix,
  dataWithSuffix,
  centerTextSuffix,
  centerTextPrefix,
  size = 120,
  colours = "default",
  noDataMessage,
  tooltip,
  showValues = true,
  isGradient = true,
  centerTextFont = "Fraunces",
  chartColorsOverride,
  selectData,
  selectedValue,
  onChange,
}: SelectPieChartKPIProps): JSX.Element => {
  return (
    <Card height="100%" corners="rounded">
      <div className="SelectPieChartKPIContainer">
        <Row spacingV="ml" align="center">
          <Column span={8}>
            <div className="HeaderLeft">
              <p className="body01">{title}</p>
              <div>{tooltip}</div>
            </div>
          </Column>
          <Column span={4} hasNoPadding>
            <Select
              data={selectData}
              value={selectedValue}
              onChange={onChange}
              corners="rounded"
              size="small"
              fontSize="body3"
            />
          </Column>
        </Row>
        <div className="SelectPieChartKPIContent">
          <PieChart
            size={size}
            data={data}
            hasSuffix={hasSuffix}
            dataWithSuffix={dataWithSuffix}
            centerTextSuffix={centerTextSuffix}
            centerTextPrefix={centerTextPrefix}
            noDataMessage={noDataMessage}
            colors={colours}
            showValues={showValues}
            isGradient={isGradient}
            centerTextFont={centerTextFont}
            chartColorsOverride={chartColorsOverride}
          />
        </div>
      </div>
    </Card>
  );
};
